import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
    const reviews = [
        {
            text: "Sakthivel Engineering consistently delivers precision-machined components with excellent dimensional accuracy. Their commitment to quality and timely delivery makes them a dependable machining partner.",
            client: "Manufacturing Industry Client",
            role: "Procurement Manager"
        },
        {
            text: "The customized CNC solutions provided by the team have significantly improved our production efficiency. Their attention to detail in milling and turning is top-notch.",
            client: "Automotive Components Ltd",
            role: "Production Head"
        },
        {
            text: "Reliable, transparent, and highly skilled. Their VMC machining capabilities are among the best in Chennai. Highly recommended for complex engineering projects.",
            client: "Precision Tools & Die",
            role: "Technical Director"
        }
    ];

    const [activeIndex, setActiveIndex] = React.useState(0);

    return (
        <section id="clients" className="testimonials section-padding">
            <div className="container">
                <h2 className="testimonials-title">
                    What Our <span className="highlight">Clients</span> Say
                </h2>

                <div className="testimonial-card">
                    <div className="quote-icon">“</div>
                    <p className="testimonial-text">
                        “{reviews[activeIndex].text}”
                    </p>
                    <div className="client-info">
                        <div className="client-avatar"></div>
                        <div className="client-details">
                            <h4>{reviews[activeIndex].client}</h4>
                            <p>{reviews[activeIndex].role}</p>
                        </div>
                    </div>
                </div>

                <div className="slider-dots">
                    {reviews.map((_, index) => (
                        <span
                            key={index}
                            className={activeIndex === index ? 'active' : ''}
                            onClick={() => setActiveIndex(index)}
                        ></span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
